<template>
  <div class="sell-sincerity-box">
    <div class="sell-sincerity">
      <img src="@/assets/image/AllGame/selectGame/chengxinmaiIcon.png" alt="">
      <div class="selll-sincerity-tip">
        <div class="selll-sincerity-tip-tittle">
          诚心卖
        </div>
        <div class="selll-sincerity-tip-text">
          卖家已购买诚心卖服务买家确定购买且付款后，若因卖家原因不能成交（法律、法规禁止交易的除外），买家可获得5元平台补贴。
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'sellSincerity'
}
</script>

<style lang="less" scoped>
.sell-sincerity-box{
  height: 28px;
}
.sell-sincerity{
  position: relative;
  display: inline-block;
  height: 28px;

  &::after{
    content: "";
    display: none;
    position: absolute;
    top: 28px;
    right: 0;
    width: 312px;
    height: 8px;
    background: transparent;
  }

  img{
    width: 64px;
    height: 28px;
    cursor: pointer;
    vertical-align: middle;
  }

  &:hover{
    &::after{
      display: block;
    }

    .selll-sincerity-tip{
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transform: translateY(0) scale(1);
    }
  }

  .selll-sincerity-tip{
    z-index: 20;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    top: 34px;
    right: 0;
    padding: 16px 18px;
    box-sizing: border-box;
    width: 312px;
    min-height: 112px;
    background: linear-gradient(135deg, rgba(26, 29, 36, 0.96) 0%, rgba(26, 29, 36, 0.94) 100%);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 4px;
    box-shadow: 0 20px 40px rgba(26, 29, 36, 0.18);
    transform: translateY(-8px) scale(.985);
    transform-origin: right top;
    transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;

    &::before,
    &::after{
      content: "";
      position: absolute;
      right: 22px;
      display: block;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }

    &::before{
      top: -7px;
      border-bottom: 7px solid rgba(255, 255, 255, 0.16);
    }

    &::after{
      top: -6px;
      border-bottom: 7px solid rgba(87, 78, 236, 0.96);
    }

    .selll-sincerity-tip-tittle{
      width: fit-content;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 4px 9px;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 20px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.18);
      border-radius: 4px;
      margin-bottom: 8px;

      &::before{
        content: '';
        display: inline-block;
        width: 7px;
        height: 7px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 50%;
        margin-right: 8px;
      }
    }

    .selll-sincerity-tip-text{
      font-size: 14px;
      line-height: 21px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.86);
    }
  }
}
</style>
